module.exports = __webpack_public_path__ + "static/media/support.6361f746.svg";